import * as React from "react";
import { cn } from "../lib/utils.js";

export type PageShellProps = {
  width?: "form" | "content" | "wide" | "fluid";
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  id?: string;
};

const widthClasses: Record<NonNullable<PageShellProps["width"]>, string> = {
  form: "max-w-3xl",
  content: "max-w-6xl",
  wide: "max-w-[96rem]",
  fluid: "max-w-none",
};

/** Declares page width and gutter ownership without introducing a card. */
export function PageShell({
  width = "content",
  children,
  className,
  contentClassName,
  id,
}: PageShellProps): React.ReactElement {
  return (
    <div id={id} className={cn("min-w-0 flex-1", className)}>
      <div
        className={cn(
          "mx-auto w-full px-4 py-4 md:px-6 md:py-6 xl:px-8",
          widthClasses[width],
          contentClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
}

export type SkipLinkProps = {
  targetId?: string;
  label?: string;
};

/** Keyboard-first bypass for repeated application navigation. */
export function SkipLink({
  targetId = "main-content",
  label = "Skip to main content",
}: SkipLinkProps): React.ReactElement {
  return (
    <a
      href={`#${targetId}`}
      className="fixed left-3 top-3 z-[100] -translate-y-20 rounded-md bg-background px-3 py-2 text-sm font-semibold text-foreground shadow-lg ring-2 ring-ring transition-transform focus:translate-y-0 motion-reduce:transition-none"
    >
      {label}
    </a>
  );
}
